export const budgetCents=value=>{
  if(typeof value!=='string'||!/^\d{1,2}(?:[.,]\d{0,2})?$/.test(value.trim()))return null;
  const [whole,fraction='']=value.trim().replace(',','.').split('.');
  const cents=Number(whole)*100+Number(fraction.padEnd(2,'0'));
  return cents>=0&&cents<=500?cents:null;
};
export const validBudget=v=>{
  if(!v||v.currency!=='USD'||v.timezone!=='UTC'||v.authorized_ceiling_cents!==500||v.enforcement_scope!=='local_reservation_only'
    ||v.quote_validation_complete!==false||v.signing_enabled!==false||v.execution_enabled!==false
    ||typeof v.settings_saved!=='boolean'||typeof v.pending_change!=='boolean'
    ||!['version','policy_version','daily_limit_cents','recorded_usd_micros','reserved_usd_micros','available_usd_micros','unresolved_count'].every(k=>Number.isSafeInteger(v[k])&&v[k]>=0)
    ||v.policy_version>v.version||v.daily_limit_cents>500||v.unresolved_count>1024
    ||typeof v.day!=='string'||!/^\d{4}-\d{2}-\d{2}$/.test(v.day)||typeof v.reset_at!=='string')return false;
  const reset=Date.parse(v.reset_at),start=Date.parse(v.day+'T00:00:00Z');
  if(!Number.isFinite(reset)||!Number.isFinite(start)||reset!==start+86400000)return false;
  if(v.available_usd_micros!==Math.max(0,v.daily_limit_cents*10000-v.recorded_usd_micros-v.reserved_usd_micros))return false;
  const state=v.pending_change?'save_pending':!v.settings_saved?'not_saved':v.unresolved_count?'uncertain':!v.daily_limit_cents?'paused':!v.available_usd_micros?'exhausted':'available';
  return v.state===state;
};